import { render, staticRenderFns } from "./travel_approval.vue?vue&type=template&id=a48de30e&"
import script from "./travel_approval.vue?vue&type=script&lang=js&"
export * from "./travel_approval.vue?vue&type=script&lang=js&"
import style0 from "./travel_approval.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports